module.exports = __webpack_public_path__ + "static/media/about_05.074b30d0.png";